import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import SubProductService from "services/Setup/Organization/SubProductService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  SubProductList: {},
  refreshList: false,
  SubProductApprovalList: {},
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
};

export const postSubProduct = createAsyncThunk(
  "subProduct/postSubProduct",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SubProductService.postSubProduct(data);
      console.log("🚀 ~ response:", response);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          // message.success({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          // message.error({
          //   status: response.data.status,
          //   content: response.data.message,
          // });
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getSubProductList = createAsyncThunk(
  "subProduct/getSubProductList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await SubProductService.getSubProductList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getSubProductApprovalList = createAsyncThunk(
  "subProduct/getSubProductApprovalList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await SubProductService.getSubProductApprovalList(
        userInput
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putSubProductApproval = createAsyncThunk(
  "subProduct/putSubProductApproval",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SubProductService.putSubProductApproval(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putSubProductRequest = createAsyncThunk(
  "subProduct/putSubProductRequest",
  async (data, { rejectWithValue }) => {
    console.log('putSubProductRequest',data);
    
    try {
      const response = await SubProductService.putSubProductRequest(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getSubProductDetail = createAsyncThunk(
  "subProduct/getSubProductDetail",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SubProductService.getSubProductDetail(data);
      if (response.status === 200) {
        if (response && response.data) {
          return response;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updateSubProduct = createAsyncThunk(
  "subProduct/updateSubProduct",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SubProductService.updateSubProduct(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteSubProduct = createAsyncThunk(
  "subProduct/deleteSubProduct",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SubProductService.deleteSubProduct(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: "Error",
        description: "Unexpected response!",
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const subProductSlice = createSlice({
  name: "subProduct",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder

      //post
      .addCase(postSubProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(postSubProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
      })
      .addCase(postSubProduct.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list
      .addCase(getSubProductList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getSubProductList.fulfilled, (state, action) => {
        state.loading = false;
        state.SubProductList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getSubProductList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //SubProduct approval list
      .addCase(getSubProductApprovalList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getSubProductApprovalList.fulfilled, (state, action) => {
        state.loading = false;
        state.SubProductApprovalList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getSubProductApprovalList.rejected, (state, action) => {
        state.loading = false;
        state.SubProductApprovalList = action.payload;
      })

      //SubProduct approval approve
      .addCase(putSubProductApproval.pending, (state) => {
        state.loading = true;
        // state.redirect = "";
      })
      .addCase(putSubProductApproval.fulfilled, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(putSubProductApproval.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //SubProduct approval request
      .addCase(putSubProductRequest.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(putSubProductRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(putSubProductRequest.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //detail
      .addCase(getSubProductDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSubProductDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(getSubProductDetail.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //update
      .addCase(updateSubProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSubProduct.fulfilled, (state, action) => {
        state.loading = false;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updateSubProduct.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //delete
      .addCase(deleteSubProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSubProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deleteSubProduct.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  //    update,
  showNotification,
  hideNotification,
  showLoading,
} = subProductSlice.actions;

export default subProductSlice.reducer;
